import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { reportActionCreators } from '~/redux/ducks/playersAndTeams/report';
import { commonMessages } from '~/utility/commonMessages';

import { TimeSelectTabBar } from './styles';

const TimeFrameSelect = () => {
    const dispatch = useDispatch();
    const timeFrame = useSelector((state) => state.playersAndTeams.report.current.timeFrame);

    const onSelectTab = (tab) => {
        dispatch(reportActionCreators.setTimeFrame(tab.key));
        dispatch(reportActionCreators.runReport());
    };

    const tabs = [
        {
            key: 'season',
            label: <FormattedMessage {...commonMessages.labels.bySeason} />,
            ariaControlId: 'season-tabpanel',
        },
        {
            key: 'game',
            label: <FormattedMessage {...commonMessages.labels.byGame} />,
            ariaControlId: 'game-tabpanel',
        },
        {
            key: 'allTime',
            label: <FormattedMessage {...commonMessages.labels.allTime} />,
            ariaControlId: 'allTime-tabpanel',
        },
    ];

    return (
        <TimeSelectTabBar
            tabs={tabs}
            selectedTab={tabs.find((tab) => tab.key === timeFrame) || tabs[0]}
            onChangeSelectedTab={onSelectTab}
        />
    );
};

export default TimeFrameSelect;
